import { render } from "./FlagAttributeGuide.vue?vue&type=template&id=678c85b6&scoped=true"
import script from "./FlagAttributeGuide.vue?vue&type=script&lang=js"
export * from "./FlagAttributeGuide.vue?vue&type=script&lang=js"

import "./FlagAttributeGuide.vue?vue&type=style&index=0&id=678c85b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678c85b6"]])

export default __exports__